/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useMemo, useState } from "react";
import * as anchor from "@project-serum/anchor";
import useSound from "use-sound";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import {
  Commitment,
  Connection,
  PublicKey,
  Transaction,
} from "@solana/web3.js";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";
import {
  awaitTransactionSignatureConfirmation,
  CANDY_MACHINE_PROGRAM,
  CandyMachineAccount,
  createAccountsForMint,
  getCandyMachineState,
  getCollectionPDA,
  mintOneToken,
  SetupState,
} from "./candy-machine";
import { AlertState, formatNumber, getAtaForMint, toDate } from "./utils";
import { MintCountdown } from "./MintCountdown";
import { MintButton } from "./MintButton";
import { GatewayProvider } from "@civic/solana-gateway-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  findGatewayToken,
  getGatewayTokenAddressForOwnerAndGatekeeperNetwork,
  onGatewayTokenChange,
} from "@identity.com/solana-gateway-ts";
//@ts-ignore
import Lottie, { useLottie } from "lottie-react";
import Fireworks from "../src/assets/lottie/fireworks.json";
import Test from "../src/assets/lottie/3.json";
import burning from "../src/assets/lottie/burning.json"; 

//ui
import Marquee from "react-fast-marquee";
import secret from "./assets/img/secret.png";
import almighty from "../src/assets/img/almighty_card.png";
import myth from "./assets/img/5.png";
import { fetchMetaForUI, getMints } from "./lib";
import { getAddresses } from "./lib/validators";
import { BsArrowRight } from "react-icons/bs";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
//@ts-ignore
import Fire from "../src/assets/sfx/burn.mp3";
import BG from "../src/assets/video/almighty.mp4";
//@ts-ignore
import Celebration from "../src/assets/sfx/celebration2.mp3";
import hero_half from "./assets/img/hero_half.png";

import { fetchMetadataFromMetaKey, decodeMetadata } from "./lib/getimages";

// console.log(images, 'images')
// console.log(Object.values(images).length);

const ConnectButton = styled(WalletDialogButton)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
`;

export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
  network: WalletAdapterNetwork;
  error?: string;
}
import { CIVIC_GATEKEEPER_NETWORK } from "./utils";
import { GatewayStatus, useGateway } from "@civic/solana-gateway-react";

const Home = (props: HomeProps) => {
  useEffect(() => {
    fetchMints();
  }, []);

  const lottieOptions = {
    loop: true,
    animationData: Fireworks,
  };

  const [playBurning] = useSound(Fire, {
    volume: 1,
  });
  const [celebration] = useSound(Celebration, {
    volume: 1,
  });

  const [celebrationEnabled, setCelebrationEnabled] = useState(false);
  const { requestGatewayToken, gatewayStatus } = useGateway();
  const connection = useConnection();
  const [webSocketSubscriptionId, setWebSocketSubscriptionId] = useState(-1);
  const [verified, setVerified] = useState(false);
  const [waitForActiveToken, setWaitForActiveToken] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });
  const [isActive, setIsActive] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [itemsRemaining, setItemsRemaining] = useState<number>();
  const [isWhitelistUser, setIsWhitelistUser] = useState(false);
  const [isPresale, setIsPresale] = useState(false);
  const [isValidBalance, setIsValidBalance] = useState(false);
  const [discountPrice, setDiscountPrice] = useState<anchor.BN>();
  const [needTxnSplit, setNeedTxnSplit] = useState(true);
  const [setupTxn, setSetupTxn] = useState<SetupState>();
  const [newNft, setNewNft] = useState(null);

  //ui
  const [selectedCard, setSelectedCard] = useState(null);

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();
  const cluster = props.network;
  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshCandyMachineState = useCallback(
    async (commitment: Commitment = "confirmed") => {
      if (!anchorWallet) {
        return;
      }
      if (props.error !== undefined) {
        setAlertState({
          open: true,
          message: props.error,
          severity: "error",
          hideDuration: null,
        });
        return;
      }

      const connection = new Connection(props.rpcHost, commitment);

      if (props.candyMachineId) {
        try {
          const cndy = await getCandyMachineState(
            anchorWallet,
            props.candyMachineId,
            connection
          );
          // console.log("Candy machine state: ", cndy);
          let active = cndy?.state.goLiveDate
            ? cndy?.state.goLiveDate.toNumber() < new Date().getTime() / 1000
            : false;
          let presale = false;

          // duplication of state to make sure we have the right values!
          let isWLUser = false;
          let userPrice = cndy.state.price;

          // whitelist mint?
          if (cndy?.state.whitelistMintSettings) {
            // is it a presale mint?
            if (
              cndy.state.whitelistMintSettings.presale &&
              (!cndy.state.goLiveDate ||
                cndy.state.goLiveDate.toNumber() > new Date().getTime() / 1000)
            ) {
              presale = true;
            }
            // is there a discount?
            if (cndy.state.whitelistMintSettings.discountPrice) {
              setDiscountPrice(cndy.state.whitelistMintSettings.discountPrice);
              userPrice = cndy.state.whitelistMintSettings.discountPrice;
            } else {
              setDiscountPrice(undefined);
              // when presale=false and discountPrice=null, mint is restricted
              // to whitelist users only
              if (!cndy.state.whitelistMintSettings.presale) {
                cndy.state.isWhitelistOnly = true;
              }
            }
            // retrieves the whitelist token
            const mint = new anchor.web3.PublicKey(
              cndy.state.whitelistMintSettings.mint
            );
            const token = (
              await getAtaForMint(mint, anchorWallet.publicKey)
            )[0];

            try {
              const balance = await connection.getTokenAccountBalance(token);
              isWLUser = parseInt(balance.value.amount) > 0;
              // only whitelist the user if the balance > 0
              setIsWhitelistUser(isWLUser);

              if (cndy.state.isWhitelistOnly) {
                active = isWLUser && (presale || active);
              }
            } catch (e) {
              setIsWhitelistUser(false);
              // no whitelist user, no mint
              if (cndy.state.isWhitelistOnly) {
                active = false;
              }
              console.log(
                "There was a problem fetching whitelist token balance"
              );
              console.log(e);
            }
          }
          userPrice = isWLUser ? userPrice : cndy.state.price;

          if (cndy?.state.tokenMint) {
            // retrieves the SPL token
            const mint = new anchor.web3.PublicKey(cndy.state.tokenMint);
            const token = (
              await getAtaForMint(mint, anchorWallet.publicKey)
            )[0];
            try {
              const balance = await connection.getTokenAccountBalance(token);

              const valid = new anchor.BN(balance.value.amount).gte(userPrice);

              // only allow user to mint if token balance >  the user if the balance > 0
              setIsValidBalance(valid);
              active = active && valid;
            } catch (e) {
              setIsValidBalance(false);
              active = false;
              // no whitelist user, no mint
              console.log("There was a problem fetching SPL token balance");
              console.log(e);
            }
          } else {
            const balance = new anchor.BN(
              await connection.getBalance(anchorWallet.publicKey)
            );
            const valid = balance.gte(userPrice);
            setIsValidBalance(valid);
            active = active && valid;
          }

          // datetime to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.date) {
            setEndDate(toDate(cndy.state.endSettings.number));
            if (
              cndy.state.endSettings.number.toNumber() <
              new Date().getTime() / 1000
            ) {
              active = false;
            }
          }
          // amount to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.amount) {
            const limit = Math.min(
              cndy.state.endSettings.number.toNumber(),
              cndy.state.itemsAvailable
            );
            if (cndy.state.itemsRedeemed < limit) {
              setItemsRemaining(limit - cndy.state.itemsRedeemed);
            } else {
              setItemsRemaining(0);
              cndy.state.isSoldOut = true;
            }
          } else {
            setItemsRemaining(cndy.state.itemsRemaining);
          }

          if (cndy.state.isSoldOut) {
            active = false;
          }

          const [collectionPDA] = await getCollectionPDA(props.candyMachineId);
          const collectionPDAAccount = await connection.getAccountInfo(
            collectionPDA
          );

          setIsActive((cndy.state.isActive = active));
          setIsPresale((cndy.state.isPresale = presale));
          setCandyMachine(cndy);

          const txnEstimate =
            892 +
            (!!collectionPDAAccount && cndy.state.retainAuthority ? 182 : 0) +
            (cndy.state.tokenMint ? 66 : 0) +
            (cndy.state.whitelistMintSettings ? 34 : 0) +
            (cndy.state.whitelistMintSettings?.mode?.burnEveryTime ? 34 : 0) +
            (cndy.state.gatekeeper ? 33 : 0) +
            (cndy.state.gatekeeper?.expireOnUse ? 66 : 0);

          setNeedTxnSplit(txnEstimate > 1230);
        } catch (e) {
          if (e instanceof Error) {
            if (
              e.message === `Account does not exist ${props.candyMachineId}`
            ) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state from candy machine with address: ${props.candyMachineId}, using rpc: ${props.rpcHost}! You probably typed the REACT_APP_CANDY_MACHINE_ID value in wrong in your .env file, or you are using the wrong RPC!`,
                severity: "error",
                hideDuration: null,
              });
            } else if (
              e.message.startsWith("failed to get info about account")
            ) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state with rpc: ${props.rpcHost}! This probably means you have an issue with the REACT_APP_SOLANA_RPC_HOST value in your .env file, or you are not using a custom RPC!`,
                severity: "error",
                hideDuration: null,
              });
            }
          } else {
            setAlertState({
              open: true,
              message: `${e}`,
              severity: "error",
              hideDuration: null,
            });
          }
          console.log(e);
        }
      } else {
        setAlertState({
          open: true,
          message: `Your REACT_APP_CANDY_MACHINE_ID value in the .env file doesn't look right! Make sure you enter it in as plain base-58 address!`,
          severity: "error",
          hideDuration: null,
        });
      }
    },
    [anchorWallet, props.candyMachineId, props.error, props.rpcHost]
  );
  const getNewNFTMetadata = async (uri: string) => {
    // 9zgdyY51rVksGHVequ7TfrZxXL6HW7qei1cMVdeTaRqh
    fetch(uri).then(async (res2) => {
      const data = await res2.json();
      console.log(data, "res2");
      const nftdata = {
        name: data.name,
        img: data.image,
      };
      console.log("setting new img ", nftdata);
      setNewNft(nftdata);
    });
  };

  const onMint = async (
    beforeTransactions: Transaction[] = [],
    afterTransactions: Transaction[] = []
  ) => {
    try {
      setIsUserMinting(true);
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        let setupMint: SetupState | undefined;
        if (needTxnSplit && setupTxn === undefined) {
          setAlertState({
            open: true,
            message: "Please sign account setup transaction",
            severity: "info",
          });
          setupMint = await createAccountsForMint(
            candyMachine,
            wallet.publicKey
          );
          let status: any = { err: true };
          if (setupMint.transaction) {
            status = await awaitTransactionSignatureConfirmation(
              setupMint.transaction,
              props.txTimeout,
              props.connection,
              true
            );
          }
          if (status && !status.err) {
            setSetupTxn(setupMint);
            setAlertState({
              open: true,
              message:
                "Setup transaction succeeded! Please sign minting transaction",
              severity: "info",
            });
          } else {
            setAlertState({
              open: true,
              message: "Mint failed! Please try again!",
              severity: "error",
            });
            setIsUserMinting(false);
            return;
          }
        } else {
          setAlertState({
            open: true,
            message: "Please sign minting transaction",
            severity: "info",
          });
        }

        const mintResult = await mintOneToken(
          candyMachine,
          wallet.publicKey,
          beforeTransactions,
          afterTransactions,
          setupMint ?? setupTxn
        );

        let status: any = { err: true };
        let metadataStatus = null;
        // console.log(mintResult, "mintResult");

        if (mintResult) {
          status = await awaitTransactionSignatureConfirmation(
            mintResult.mintTxId,
            props.txTimeout,
            props.connection,
            true
          );

          metadataStatus =
            await candyMachine.program.provider.connection.getAccountInfo(
              mintResult.metadataKey,
              "processed"
            );
          console.log("Metadata status: ", !!metadataStatus);
        }

        if (status && !status.err && metadataStatus) {
          console.log(mintResult.metadataKey.toBase58(), "metadataKey");
          await getNewNFTMetadata(decodeMetadata(metadataStatus.data).data.uri);
          console.log(metadataStatus, "metadatastatus");
          // manual update since the refresh might not detect
          // the change immediately
          const remaining = itemsRemaining! - 1;
          setItemsRemaining(remaining);
          setIsActive((candyMachine.state.isActive = remaining > 0));
          candyMachine.state.isSoldOut = remaining === 0;
          setSetupTxn(undefined);
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
            hideDuration: 7000,
          });
          refreshCandyMachineState("processed");
        } else if (status && !status.err) {
          setAlertState({
            open: true,
            message:
              "Mint likely failed! Anti-bot SOL 0.01 fee potentially charged! Check the explorer to confirm the mint failed and if so, make sure you are eligible to mint before trying again.",
            severity: "error",
            hideDuration: 8000,
          });
          refreshCandyMachineState();
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
          refreshCandyMachineState();
        }
      }
    } catch (error: any) {
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (!error.message) {
          message = "Transaction timeout! Please try again.";
        } else if (error.message.indexOf("0x137")) {
          console.log(error);
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          console.log(error);
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
      // updates the candy machine state to reflect the latest
      // information on chain
      refreshCandyMachineState();
    } finally {
      setIsUserMinting(false);
    }
  };

  const toggleMintButton = () => {
    let active = !isActive || isPresale;

    if (active) {
      if (candyMachine!.state.isWhitelistOnly && !isWhitelistUser) {
        active = false;
      }
      if (endDate && Date.now() >= endDate.getTime()) {
        active = false;
      }
    }

    if (
      isPresale &&
      candyMachine!.state.goLiveDate &&
      candyMachine!.state.goLiveDate.toNumber() <= new Date().getTime() / 1000
    ) {
      setIsPresale((candyMachine!.state.isPresale = false));
    }

    setIsActive((candyMachine!.state.isActive = active));
  };

  useEffect(() => {
    refreshCandyMachineState();
  }, [
    anchorWallet,
    props.candyMachineId,
    props.connection,
    refreshCandyMachineState,
  ]);

  useEffect(() => {
    (function loop() {
      setTimeout(() => {
        refreshCandyMachineState();

        loop();
      }, 20000);
    })();
  }, [refreshCandyMachineState]);

  useEffect(() => {
    console.log("selected card is ", selectedCard);
    if (selectedCard) mint();
  }, [selectedCard]);

  useEffect(() => {
    if (newNft?.img) {
      setTimeout(() => {
        playBurning();
        setTimeout(() => {
          celebration();
          setCelebrationEnabled(true);
          console.log("celebration enabled");
          setTimeout(() => {
            setCelebrationEnabled(false);
          }, 6000);
        }, 3000);
      }, 1000);
    }
  }, [newNft]);

  const mint = async () => {
    if (candyMachine?.state.isActive && candyMachine?.state.gatekeeper) {
      const network =
        candyMachine.state.gatekeeper.gatekeeperNetwork.toBase58();
      if (network === CIVIC_GATEKEEPER_NETWORK) {
        if (gatewayStatus === GatewayStatus.ACTIVE) {
          await onMint();
        } else {
          // setIsMinting(true);
          setWaitForActiveToken(true);
          await requestGatewayToken();
          console.log("after: ", gatewayStatus);
        }
      } else if (
        network === "ttib7tuX8PTWPqFsmUFQTj78MbRhUmqxidJRDv4hRRE" ||
        network === "tibePmPaoTgrs929rWpu755EXaxC7M3SthVCf6GzjZt"
      ) {
        setClicked(true);
        const gatewayToken = await findGatewayToken(
          connection.connection,
          wallet.publicKey!,
          candyMachine.state.gatekeeper.gatekeeperNetwork
        );

        if (gatewayToken?.isValid()) {
          await onMint();
        } else {
          window.open(
            `https://verify.encore.fans/?gkNetwork=${network}`,
            "_blank"
          );

          const gatewayTokenAddress =
            await getGatewayTokenAddressForOwnerAndGatekeeperNetwork(
              wallet.publicKey!,
              candyMachine.state.gatekeeper.gatekeeperNetwork
            );

          setWebSocketSubscriptionId(
            onGatewayTokenChange(
              connection.connection,
              gatewayTokenAddress,
              () => setVerified(true),
              "confirmed"
            )
          );
        }
      } else {
        setClicked(false);
        throw new Error(`Unknown Gatekeeper Network: ${network}`);
      }
    } else {
      await onMint();
      setClicked(false);
    }
  };
  //ui
  const [counter, setCounter] = useState(0);
  const [mintedNft, setMintedNft] = useState([]);
  const [loadingNfts, setLoadingNfts] = useState(false);
  const fetchMints = async (val = "") => {
    // console.log("Downloading your data.", { isLoading: true });
    // setLoading(true);
    setLoadingNfts(true);
    getMints(val, props.connection, setCounter)
      .then(async (res: any) => {
        // console.log(res, "res");
        const mints = res;

        const parsed = getAddresses(mints);
        // console.log(
        //   "Downloading your metadata"
        // );

        //@ts-ignore
        fetchMetaForUI(parsed[0], setCounter, props.connection).subscribe({
          next: (e) => {
            console.log(e, "data");
            setMintedNft(e);
          },
          error: (e) => {
            console.log(e, "error meta");
          },
          complete: () => {
            setLoadingNfts(false);
            console.log("completed");
          },
        });
      })
      .catch((e) => {
        console.log(e, "error");
      })
      .finally(() => {
        console.log("done");
        setCounter(0);
      });
  };

  const refresh = () => {
    fetchMints();
    setSelectedCard(null);
    setNewNft(null);
  };

  const { View } = useLottie(lottieOptions);
  // const Testing = useLottie(lottieOptions2);
  console.log(
    new Date(candyMachine?.state?.goLiveDate.toNumber()).toLocaleDateString(),
    "DATE"
  );
  console.log(
    (candyMachine?.state?.price?.toNumber() / Math.pow(10, 9)).toFixed(3),
    " SOL",
    "cmv2"
  );
  return (
    <div className="relative bg-green-00">
      <div className="backgroundvideo fixed top-0 bottom-0 left-0 right-0 bg-red-00  bg-opacity-50">
        <video
          loop
          autoPlay
          muted
          id="bg-video"
          className="h-full w-full bg-blue-00 lg:object-contain md:object-cover "
          style={{
            zIndex: -1,
            objectFit: "cover",
          }}
        >
          <source src={BG} type="video/mp4" />
        </video>
      </div>
      <div className=" bg1 text-black relative">
        {
          <div
            style={{ display: !celebrationEnabled ? "none" : "block" }}
            className="fixed top-0 bottom-0 left-0 right-0 z-50 "
          >
            {View}
          </div>
        }

        {newNft?.img && (
          <div className="fixed z-50 min-h-screen px-4 py-4 flex justify-end  items-end w-full">
            <button
              onClick={refresh}
              className="px-8 text-2xl rounded-lg py-3 font-bold bg-white bg-opacity-70"
            >
              Mint Again
            </button>
          </div>
        )}

        <div className="min-h-screen lg:w-4/5 bg-green-00 flex flex-col justify-between py-16">
          {/* <div className=" flex-1 center lg:pr-6">
            <div className="aegis1 text-3xl lg:text-4xl font-bold text-center text-white">
              MAGES <br />
              COLLECTION
            </div>
          </div>
          <div className="center">
            <div className="bg-black bg-opacity-50 rounded p-6">
              <div className="">
                <Link href="#nft" color={"inherit"}>
                  <div className=" text-xl lg:text-2xl font-bold glow text-white text-center">
                    Mint
                  </div>
                </Link>
              </div>
              <div className="flex justify-center">
                <div className="text-center text-2xl rounded-lg font-bold text-brand_gold brightness-200">
                  IMAGINARIUM
                </div>
              </div>
              <div className="pt-3 font-bold text-sm text-center tracking-widest text-white">
                <p>Select a card below</p>
              </div>
            </div>
          </div> */}
        </div>
        <div id="nft" className="min-h-screen ">
          {wallet.connected ? (
            <>
              <div className="center space-x-4">
                <div>
                  {candyMachine &&
                  candyMachine.state &&
                  isActive &&
                  endDate &&
                  Date.now() < endDate.getTime() ? (
                    <>
                      <MintCountdown
                        key="endSettings"
                        date={getCountdownDate(candyMachine)}
                        style={{ justifyContent: "flex-end" }}
                        status="COMPLETED"
                        onComplete={toggleMintButton}
                      />
                      <Typography
                        variant="caption"
                        align="center"
                        display="block"
                        style={{ fontWeight: "bold" }}
                      >
                        TO END OF MINT
                      </Typography>
                    </>
                  ) : (
                    <>
                      <MintCountdown
                        key="goLive"
                        date={getCountdownDate(candyMachine)}
                        style={{ justifyContent: "flex-end" }}
                        status={
                          candyMachine?.state?.isSoldOut ||
                          (endDate && Date.now() > endDate.getTime())
                            ? "COMPLETED"
                            : isPresale
                            ? "PRESALE"
                            : "LIVE"
                        }
                        onComplete={toggleMintButton}
                      />
                      {isPresale &&
                        candyMachine?.state?.goLiveDate &&
                        candyMachine?.state?.goLiveDate.toNumber() >
                          new Date().getTime() / 1000 && (
                          <Typography
                            variant="caption"
                            align="center"
                            display="block"
                            style={{
                              fontWeight: "bold",
                              color: "white",
                              padding: "6px",
                            }}
                          >
                            UNTIL PUBLIC MINT
                          </Typography>
                        )}
                    </>
                  )}
                </div>
                {candyMachine && (
                  <div className="py-6">
                      <div className="text-center text-sm  tracking-widest bg-brand_gold space-y-2 bg-opacity-50 rounded-lg px-9 py-2 text-white font-bold">
                    <p>
                      MINT PRICE:
                      <span className="pl-2">
                        {(
                          candyMachine?.state?.price?.toNumber() /
                          Math.pow(10, 9)
                        ).toFixed(3)}
                      </span>
                      <span className="px-1">SOL</span>
                    </p>
                    <p>
                      NFT AVAILABLE:
                      <span className="pl-2">
                        {candyMachine?.state?.itemsRemaining}
                      </span>
                    </p>
                  </div>
                  </div>
                )}
              </div>
              {candyMachine && !loadingNfts ? (
                <CardMarquee
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  mintedNft={mintedNft}
                  isUserMinting={isUserMinting}
                  newNft={newNft}
                  lottieOptions={lottieOptions}
                  candyMachine={candyMachine}
                  celebrationEnabled={celebrationEnabled}
                />
              ) : (
                <div className="py-8">
                  <p className="center font-bold h-screen text-white text-xl bg-gray-900 bg-opacity-50 py-6">
                    Candy Machine Loading...
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="center ">
              <div className="center cursor-pointer py-6">
                <ConnectButton>Connect Wallet</ConnectButton>
              </div>
            </div>
          )}
        </div>
        <div className="text-center text-2xl font-semibold text-white pb-8">
          <p className="glow">WELCOME TO IMAGINARIUM</p>
        </div>
      </div>
    </div>
  );
};

const CardMarquee = (props: any) => {
  const setSelectedCard = props.setSelectedCard;
  const mintedNft = props.mintedNft;
  return (
    <div className="backdrop-blur-md backdrop-filter ">
      <CardList
        starts={0}
        direction={"left"}
        setSelectedCard={setSelectedCard}
        selectedCard={props.selectedCard}
        mintedNft={mintedNft}
        newNft={props.newNft}
      />
      <CardList
        starts={10}
        direction={"right"}
        setSelectedCard={setSelectedCard}
        selectedCard={props.selectedCard}
        mintedNft={mintedNft}
        newNft={props.newNft}
      />
      <CardList
        starts={20}
        direction={"left"}
        setSelectedCard={setSelectedCard}
        selectedCard={props.selectedCard}
        mintedNft={mintedNft}
        newNft={props.newNft}
      />
      <CardList
        starts={30}
        direction={"right"}
        setSelectedCard={setSelectedCard}
        selectedCard={props.selectedCard}
        mintedNft={mintedNft}
        newNft={props.newNft}
      />
      <CardList
        starts={40}
        direction={"left"}
        setSelectedCard={setSelectedCard}
        selectedCard={props.selectedCard}
        mintedNft={mintedNft}
        newNft={props.newNft}
      />
    </div>
  );
};

const CardList = (props: any) => {
  const starts = props.starts;
  const direction = props.direction;
  const arr = new Array(10).fill(1);
  const setSelectedCard = props.setSelectedCard;
  const selectedCard = props.selectedCard;
  const mintedNft = props.mintedNft;
  const isUserMinting = props.isUserMinting;
  const newNft = props.newNft;
  // console.log(arr, "new array");

  return (
    <Marquee
      play={!selectedCard ? true : false}
      // play={false}
      direction={direction}
      pauseOnHover
      pauseOnClick
      gradient={false}
      speed={props.candyMachine?.state?.itemsRemaining < 10 ? 100 : 30}
    >
      {arr.map((item, i) => {
        const activeNft = selectedCard === starts + i;
        const sold = mintedNft.filter((item) => item.id === starts + i).length
          ? mintedNft?.filter((item) => item.id === starts + i)[0]?.img
          : false;

        return (
          <div
            key={starts + i}
            id={activeNft ? "activeNFT" : ""}
            className={
              selectedCard ? " p-2 relative" : " p-2 cursor-pointer relative"
            }
            style={{ width: "300px", minHeight: "300px", height: "300px" }}
          >
            <div
              onClick={() => {
                if (!selectedCard) {
                  setSelectedCard(starts + i);
                }
              }}
              className=" h-full w-full relative  flex-col center"
            >
              {activeNft ? (
                <div>
                  {newNft?.img ? (
                    <div
                      className="center"
                      style={{
                        width: "100%",
                        height: `100%`,
                        objectFit: "cover",
                        padding: `20px`,
                      }}
                    >
                      <div
                        className="absolute bg-red-00 bg-opacity-25 z-50 center"
                        style={{
                          top: "0px",
                          left: "0px",
                        }}
                      >
                        <F />
                      </div>
                      <img
                        style={{
                          width: "100%",
                          height: `100%`,
                          objectFit: "cover",
                          padding: `20px`,
                        }}
                        className=" relative z-10"
                        src={newNft?.img}
                      />
                    </div>
                  ) : (
                    <img
                      //@ts-ignore
                      style={{
                        width: "100%",
                        height: `100%`,
                        objectFit: "cover",
                        padding: `${newNft?.img ? "60px" : "20px"}`,
                      }}
                      className="vignette-inset bg-brand_gold bg-opacity-70"
                      src={almighty}
                    />
                  )}
                </div>
              ) : (
                <img
                  //@ts-ignore
                  style={{
                    width: "100%",
                    height: `100%`,
                    objectFit: "cover",
                    padding: `${sold ? "30px" : "20px"}`,
                  }}
                  key={i}
                  //@ts-ignore
                  className="vignette-inset"
                  src={sold ? sold : almighty}
                />
              )}
              {/* {activeNft && newNft && (
                <div id="fire" className="absolute top-0 bottom-0 ">
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src={fire}
                  />
                </div>
              )} */}
              {isUserMinting && activeNft && (
                <div className="absolute text-white bottom-16 right-16 text-sm">
                  <CircularProgress color="inherit" size={16} />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </Marquee>
  );
};

const getCountdownDate = (
  candyMachine: CandyMachineAccount
): Date | undefined => {
  if (
    candyMachine?.state?.isActive &&
    candyMachine?.state?.endSettings?.endSettingType.date
  ) {
    return toDate(candyMachine.state.endSettings.number);
  }

  return toDate(
    candyMachine?.state?.goLiveDate
      ? candyMachine?.state?.goLiveDate
      : candyMachine?.state?.isPresale
      ? new anchor.BN(new Date().getTime() / 1000)
      : undefined
  );
};

const F = () => {
  return (
    <Lottie
      animationData={burning}
      loop={false}
      style={{ minWidth: "170%", minHeight: "170%" }}
    />
  );
};

export default Home;
